/******
 *
 * {
 agentId: "alpha.agent-1"
 lastIocSeenTime: 1569004711938364400
 numberOfDetections: 21
 numberOfHosts: 2
 numberOfLateralMovements: 4
 riskMomentum: 0
 riskScore: 115
 startTime: 1569000156783173400
 state: "ACTIVE"
 trailIdHash: "alpha.agent-1:7747126"
 "trailRiskHistInfoList": [
 {
 "agentId": "alpha.agent-4",
 "scoreContribution": 1,
 "seenTime": 1557710221155,
 "trailId": "20176710"
 }
 ]
 }
 *
 *
 */
import { DATETIME_FORMAT } from '@/constants/datetime.constants'

const trailsMetaInfo = {
  meta: {
    columns: [
      {
        datatype: 'string',
        description: 'Progression Identifier',
        label: 'Progression ID',
        sortable: true,
        name: 'trailIdLabel',
        display: 'link',
        pathTo: 'attack-track-details',
        params: {
          name: 'trailId',
          keyLookup: 'trailIdHash'
        },
        'min-width': 130
      },
      {
        datatype: 'string',
        description: 'Fingerprint',
        label: 'Fingerprint',
        sortable: true,
        display: 'fingerprintLabel',
        name: 'fingerprint',
        'min-width': 150
      },
      {
        datatype: 'string',
        description: 'Severity',
        label: 'Severity',
        sortable: true,
        name: 'progressionSeverity',
        'min-width': 125,
        display: 'colorTag',
        displayKey: [
          {
            key: 'HIGH',
            display: 'High',
            color: '#FEF0F0',
            textColor: '#BF3951',
            border: '0.5px solid #F5B0B0'
          },
          {
            key: 'MEDIUM',
            display: 'Medium',
            color: '#FAECD8',
            textColor: '#654B23',
            border: '0.5px solid #EDCB98'
          },
          {
            key: 'LOW',
            display: 'Low',
            color: '#FDF6EC',
            textColor: '#654B23',
            border: '0.5px solid #EDCB98'
          },
          {
            key: 'CRITICAL',
            display: 'Critical',
            color: '#FDE2E2',
            textColor: '#732231',
            border: '0.5px solid #F5B0B0'
          }
        ]
      },
      {
        datatype: 'number',
        description: 'Detections',
        label: 'Detections',
        name: 'numberOfDetections',
        display: 'link',
        pathTo: 'trail-iocs',
        query: [
          {
            name: 'trailId',
            keyLookup: 'trailIdHash'
          },
          { name: 'trailLabel', keyLookup: 'trailIdLabel' },
          { name: 'trailState', keyLookup: 'state' }
        ],
        sortable: true,
        'min-width': 120
      },
      {
        datatype: 'number',
        description: 'Hosts Involved',
        label: 'Hosts Involved',
        name: 'numberOfHosts',
        sortable: true,
        'min-width': 150
      },
      {
        datatype: 'number',
        description: 'Lateral Movements',
        label: 'Lateral Movements',
        name: 'numberOfLateralMovements',
        sortable: true,
        'min-width': 175
      },
      {
        datatype: 'dwelltime_string',
        format: DATETIME_FORMAT,
        description: 'Detection Time',
        label: 'Dwell Time',
        name: 'dwellTime',
        sortable: true,
        'min-width': 150
      },
      {
        datatype: 'objectpath',
        description: 'Cyber Kill Chain',
        label: 'Cyber Kill Chain',
        sortable: false,
        name: 'killChainData',
        display: 'component',
        component: 'CyberKillChainTickChart',
        componentKey: 'trailIdLabel',
        'min-width': 150
      },
      {
        datatype: 'objectpath',
        description: 'Recommendation mitigation progress',
        label: 'Mitigation Progress',
        sortable: false,
        name: '',
        display: 'component',
        component: 'RecommendationProgress',
        componentKey: 'trailIdLabel',
        'min-width': 150
      },
      {
        datatype: 'datetime',
        format: DATETIME_FORMAT,
        description: 'Last Detection Time',
        label: 'Latest Detection',
        name: 'lastIocSeenTime',
        sortable: true,
        'min-width': 200
      },
      {
        datatype: 'string',
        description: 'Trail State',
        display: 'stateTag',
        label: 'State',
        name: 'state',
        'min-width': 100,
        displayKey: [
          {
            key: 'ACTIVE',
            display: 'Active',
            color: '#F0F9EB',
            textColor: '#315D1C',
            border: '0.5px solid #AEDB97'
          },
          {
            key: 'INACTIVE',
            display: 'Inactive',
            color: '#c6cbd2',
            textColor: '#292c32'
          },
          {
            key: 'MITIGATED',
            display: 'Mitigated',
            color: '#ECF5FF',
            textColor: '#003A80',
            border: '0.5px solid #9AC9FA'
          },
          {
            key: 'REOPENED',
            display: 'Reopened',
            color: '#FDF6EC',
            textColor: '#654B23',
            border: '0.5px solid #EDCB98'
          }
        ]
      },
      {
        datatype: 'objectpath',
        description: 'Owner Identifier',
        label: 'Owner',
        display: 'component',
        displayTextName: 'ownerId.fullname',
        component: 'UserButton',
        componentKey: 'ownerId.fullname',
        sortable: true,
        name: 'ownerId.fullname',
        'min-width': 150
      },
      {
        datatype: 'objectpath',
        description: 'Jira Ticket Link',
        label: 'Jira Ticket Link',
        'min-width': 150,
        sortable: true,
        name: 'jiraTicketId',
        display: 'jiraLink',
        link: 'jiraTicketLink'
      }
    ]
  }
}

export { trailsMetaInfo }



// WEBPACK FOOTER //
// ./src/column-header/trail/trails-meta.js